/**
 * 冒険メニュー遷移先からホームへ戻る共通ボタン
 */

import React from 'react';
import { Pressable, Text } from '../../../shared/components/WebPrimitives';

/** ホーム戻りボタンのプロパティ */
type VisitorHomeBackButtonProps = {
  onPress: () => void;
};

/**
 * 冒険者ホームへ確実に戻る共通ボタンを表示する
 * 「↻ 更新」と同じ44px四方にし、文字を大きくしてもヘッダー1行の見出し欄を横に押し潰さない
 * @param {VisitorHomeBackButtonProps} props - プロパティ
 * @returns {React.JSX.Element} ホーム戻りボタン
 */
const VisitorHomeBackButton = ({
  onPress,
}: VisitorHomeBackButtonProps): React.JSX.Element => {
  return (
    <Pressable
      accessibilityHint="冒険メニューがあるホーム画面へ移動します"
      accessibilityLabel="冒険者ホームへ戻る"
      accessibilityRole="button"
      className="h-11 w-11 shrink-0 items-center justify-center border-2 border-app-quest-night bg-[#FFF8DD] shadow-[2px_2px_0_rgba(22,36,58,0.24)]"
      onPress={onPress}
      testID="visitor-home-back-button"
    >
      <Text accessible={false} className="text-lg leading-5 font-extrabold text-app-quest-night">
        ←
      </Text>
      <Text accessible={false} className="text-[9px] leading-3 font-bold text-app-quest-night">
        戻る
      </Text>
    </Pressable>
  );
};

export default VisitorHomeBackButton;
